import MemberBusinessAddressModelBase from '../_generated/modelBases/member-business-address-model-base';

export default class MemberBusinessAddressModel extends MemberBusinessAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
